import Rollbar from 'rollbar';

const frontEndProjectToken = 'f0dfae4da37841b38be47c1a1883d7d9';
const isProduction = process.env.NODE_ENV === 'production';

const ignoreMessages = () => {
  const messages = [
    'Network Error',
    'Request failed with status code 404',
    'timeout of 0ms exceeded',
    'Request aborted',
    'Invalid token specified'
  ];
  return messages;
};

const logError = (error, info) => {
  if (isProduction && !ignoreMessages().includes(error.message)) {
    const rollbar = new Rollbar({
      accessToken: frontEndProjectToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      checkIgnore,
      hostSafeList: ['*.commerce7.com', 'cdn.commerce7.com'],
      payload: {
        environment: process.env.NODE_ENV || 'development',
        version: process.env.CODEBUILD_RESOLVED_SOURCE_VERSION,
        server: {
          root: 'webpack:///./'
        },
        client: {
          javascript: {
            code_version: process.env.CODEBUILD_RESOLVED_SOURCE_VERSION,
            guess_uncaught_frames: true
          }
        }
      }
    });
    // eslint-disable-next-line no-console
    console.log(
      'Something went wrong. A report has been sent to the Administrator. Please try to reload the page.'
    );
    rollbar.error(error);
  } else {
    // eslint-disable-next-line no-console
    console.log(error);
    // eslint-disable-next-line no-console
    console.log(info);
  }
};

export default logError;

const checkIgnore = function (isUncaught, args, payload) {
  const trace = payload?.body?.trace;
  const frames = trace?.frames || [];

  // Check if error comes from our application code
  const isFromOurCode = frames.some(
    (frame) =>
      frame.filename?.includes('commerce7') ||
      frame.filename?.includes('/assets/') ||
      frame.filename?.includes('webpack:///./')
  );

  return !isFromOurCode;
};
